import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: 'particle-delete-conversations-dialog',
  templateUrl: './delete-conversations-dialog.component.html',
  styleUrls: ['./delete-conversations-dialog.component.scss']
})
export class DeleteConversationsDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  numberOfConversationIds: number;
  onOkClicked(): boolean {
    return true;
  }

  constructor() {
    this.numberOfConversationIds = 0;
  }

  ngOnInit() {
    this.numberOfConversationIds = this.data.input.numberOfConversationIds;
  }

}
